<template>
  <div id="login">
    <div id="particles"></div>
    <div class="loginConbox">
      <div class="header">
        <div class="title">
          {{ $store.state.eduWebConfig.hospitalWebConfigInfo.hospitalName }}
        </div>
        <div
          class="subTitle"
          v-if="$store.state.eduWebConfig.hospitalWebConfigInfo.isShowWebName"
        >
          {{ $store.state.eduWebConfig.hospitalWebConfigInfo.webName }}
        </div>
        <img class="lyLogo" src="/static/images/ly_logo.png" alt="" />
      </div>
      <div class="loginBox">
        <div class="loginCon">
          <p class="title">用户登录</p>
          <el-form
            ref="userform"
            :model="loginForm"
            :rules="Rules"
            status-icon
            v-enterToNext="true"
            class="demo-ruleForm"
          >
            <el-form-item prop="Username">
              <label for="" class="label">用户名</label>

              <el-input
                size="medium"
                class="inputs"
                placeholder="请输入登录账号"
                v-model="loginForm.Username"
              >
                <i slot="prefix" class="el-input__icon el-icon-user-solid"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="Password">
              <label for="" class="label">密码</label>
              <el-input
                type="password"
                @keyup.enter.native="submitForm"
                size="medium"
                class="inputs"
                placeholder="请输入登录密码"
                v-model="loginForm.Password"
              >
                <i slot="prefix" class="el-input__icon el-icon-unlock"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <span class="gotest" @click="gotest">测评作答入口</span>
            </el-form-item>
            <el-form-item>
              <el-button class="subBtn" type="primary" @click="submitForm">
                <i style="margin-right: 5px" :class="btnclass"></i>登录
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 跳转页面弹框 -->
    <!-- <el-dialog title="提示" :visible.sync="dialogVisible" width="500px" :close-on-click-modal='false'  :close-on-press-escape="false" :show-close='false'>
	  <div style="padding:20px 10px ;text-align:center">网站域名已更改为<span style="color: #56a9ff;cursor: pointer;" @click="locationHref">www.lanyunxinli.com</span><span style="color:red">{{nowDate}}</span>秒后将自动跳转 </div>
	  <span slot="footer" class="dialog-footer">
	    <el-button type="primary" @click="locationHref">立即跳转</el-button>
	  </span>
	</el-dialog> -->
    <div class="foot">
      <p>
        <a  
        style="color: #e1e1e1; text-decoration: none"
         href="https://beian.mps.gov.cn/#/query/webSearch?code=51010702042930" 
         rel="noreferrer" target="_blank"
         ><img style="height: 15px; margin-right: 6px; margin-bottom: -4px" src="/static/images/备案图标.png"
         >川公网安备51010702042930</a>
      </p>
      <p>
        <a
          target="_bank"
          style="color: #e1e1e1; text-decoration: none"
          href="https://beian.miit.gov.cn"
          >蜀ICP备20012822号-2</a
        >
      </p>
      <p>© 2020 四川蓝韵心理咨询服务有限公司</p>
      <p>© 2020 成都丰捷信科技有限公司</p>
      <!-- <p>成都丰捷信科技有限公司提供技术支持</p> -->
    </div>
  </div>
</template>
<script>
import { Axios } from "@/common/request";
import vuex from "vuex";
import particles from "particles.js";
export default {
  data() {
    return {
      smdl: true,
      // nowDate:10,
      // dialogVisible:true,
      loginForm: {
        Username: "",
        Password: "",
      },
      text: "心理健康管理服务云平台",
      Rules: {
        // Username: [
        //   { required: true, message: "请输入用户名", trigger: "blur" }
        // ],
        // Password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      config: {
        APP_KEY: "",
        IMGHOST_URL: "", //图片地址
      },
      loginflag: false,
    };
  },
  created() {
    this.GetDomain(window.location.host);
    //let self = this;
    // setInterval(()=>{
    //   self.nowDate--;
    // },1000)
    // setTimeout(()=>{
    //   self.locationHref();
    // },10000)
  },
  methods: {
    // locationHref(){
    //    window.location.href='http://www.lanyunxinli.com'
    // },
    //   跳转答题页面
    gotest() {
      this.$router.push("/register");
    },
    GetDomain(url) {
      let that = this;
      Axios("HIM/GetDomainData", "get", { domain: url }, that).then((res) => {
        if (res.Status === 1) {
          this.text = res.Data.Name;
        }
      });
    },
    submitForm() {
      let that = this;
      if (this.loginForm.UserName === "" || this.loginForm.Password === "") {
        this.$message({
          showClose: true,
          message: "账号或密码不能为空",
          type: "error",
        });
        return false;
      } else {
        this.loginflag = true;
        //请求后台返回数据
        this.$refs["userform"].validate((valid) => {
          // 将 UserName 设置为 token 存储在 store，仅为测试效果，实际存储 token 以后台返回为准
          if (valid) {
            Axios("Login", "post", that.loginForm, that)
              .then((ret) => {
                this.loginflag = false;
                console.log(ret.Status, "++++");
                if (ret.Status == 1) {
                  console.log(ret, "++++");
                  window.sessionStorage.setItem("token", ret.Data.Token);
                  that.$store
                    .dispatch("setToken", ret.Data.Token)
                    .then(() => {
                      if (ret.Data.RoleID == 5) {
                        that.$store.dispatch("setRole", {
                          UserID: ret.Data.UserID,
                          LoginName: ret.Data.LoginName,
                          UserName: ret.Data.UserName,
                          RoleName: ret.Data.RoleName,
                          RoleID: ret.Data.RoleID,
                          Menus: ret.Data.Menus,
                          DepartmentID: ret.Data.DepartmentID,
                          DepartmentName: ret.Data.DepartmentName,
                          Avatar: ret.Data.Avatar,
                          HospitalName: ret.Data.HospitalName,
                          HospitalID: ret.Data.HospitalID,
                        });
                        const Menus = JSON.stringify(ret.Data.Menus[0].Menus);
                        window.sessionStorage.setItem("Menus", Menus);
                        that.$message({
                          showClose: true,
                          message: "登录成功!",
                          type: "success",
                        });
                        that.$router.replace({ path: "/register" });
                      } else if (ret.Data.RoleID == 1) {
                        console.log("走管理员");
                        var newMenus = [];
                        ret.Data.Menus[0].Menus.forEach((item) => {
                          if (item.BusinessType == 1) {
                            newMenus.push(item);
                          }
                        });

                        if (ret.Data.HospitalID == 0) {
                          that.$store.dispatch("setRole", {
                            UserID: ret.Data.UserID,
                            LoginName: ret.Data.LoginName,
                            UserName: ret.Data.UserName,
                            RoleName: ret.Data.RoleName,
                            RoleID: ret.Data.RoleID,
                            Menus: newMenus,
                            DepartmentID: ret.Data.DepartmentID,
                            DepartmentName: ret.Data.DepartmentName,
                            Avatar: ret.Data.Avatar,
                            // HospitalName: ret.Data.Hospitals[0].Name,
                            // HospitalID: ret.Data.Hospitals[0].ID,
                            HospitalID: ret.Data.HospitalID,
                            Hospitals: ret.Data.Hospitals,
                          });
                          window.sessionStorage.setItem(
                            "Menus",
                            JSON.stringify(newMenus)
                          );
                        } else {
                          window.sessionStorage.setItem(
                            "info",
                            JSON.stringify(ret.Data)
                          );
                          window.sessionStorage.setItem(
                            "Menus",
                            JSON.stringify(ret.Data.Menus[0].Menus)
                          );
                          that.$store.dispatch("setRole", {
                            UserID: ret.Data.UserID,
                            LoginName: ret.Data.LoginName,
                            UserName: ret.Data.UserName,
                            RoleName: ret.Data.RoleName,
                            RoleID: ret.Data.RoleID,
                            Menus: ret.Data.Menus,
                            DepartmentID: ret.Data.DepartmentID,
                            DepartmentName: ret.Data.DepartmentName,
                            Avatar: ret.Data.Avatar,
                            HospitalName: ret.Data.Hospitals[0].Name,
                            HospitalID: ret.Data.Hospitals[0].ID,
                            Hospitals: ret.Data.Hospitals,
                          });
                        }
                        that.$message({
                          showClose: true,
                          message: "登录成功!",
                          type: "success",
                        });
                        that.$router.replace({ path: "/index" });
                        return;
                      } else if (ret.Data.RoleID != 1) {
                        if (ret.Data.HospitalID == 0) {
                          that.$message({
                            showClose: true,
                            message: "账号不可用",
                            type: "error",
                          });
                          return;
                        } else {
                          that.$store.dispatch("setRole", {
                            UserID: ret.Data.UserID,
                            LoginName: ret.Data.LoginName,
                            UserName: ret.Data.UserName,
                            RoleName: ret.Data.RoleName,
                            RoleID: ret.Data.RoleID,
                            Menus: ret.Data.Menus,
                            DepartmentID: ret.Data.DepartmentID,
                            DepartmentName: ret.Data.DepartmentName,
                            Avatar: ret.Data.Avatar,
                            HospitalName: ret.Data.Hospitals[0].Name,
                            HospitalID: ret.Data.Hospitals[0].ID,
                            // HospitalID: ret.Data.HospitalID,
                          });
                          const Menus = JSON.stringify(ret.Data.Menus[0].Menus);
                          window.sessionStorage.setItem("Menus", Menus);
                          that.$message({
                            showClose: true,
                            message: "登录成功!",
                            type: "success",
                          });
                          that.$router.replace({ path: "/ordinaryIndex" });
                          return;
                        }
                      }
                    })
                    .catch((res) => {
                      that.$message({
                        showClose: true,
                        message: res,
                        type: "error",
                      });
                    });
                } else {
                  that.$message({
                    showClose: true,
                    message: ret.Message,
                    type: "error",
                  });
                }
              })
              .catch((res) => {
                that.$message({
                  showClose: true,
                  message: res,
                  type: "error",
                });
                this.loginflag = false;
              });
          } else {
            return false;
          }
        });
      }
    },
    message() {},
    init() {
      let that = this;
      console.log(that.config);
      that.$store.dispatch("setConfig", that.config);
      console.log(that.$store);
    },
  },
  computed: {
    btnclass: function () {
      if (this.loginflag == true) return "el-icon-loading";
      else return "";
    },
  },
  beforeCreate() {
    window.sessionStorage.clear();
  },
  mounted() {
    this.message();
    this.init();
    particlesJS.load("particles", "static/particles.json");
  },
};
</script>

<style lang="less" scoped>
.gotest {
  color: #918d9a;
  font-family: Arial Normal, Arial;
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  cursor: pointer;
  letter-spacing: 2px;
}
.gotest:hover {
  color: #091d7c;
}
.inputs {
  font-size: 18px;
  line-height: 50px;
}

#particles {
  height: 100%;
}

.el-input--medium .el-input__inner {
  height: 50px;
}

.rightText {
  color: white;
  font-size: 35px;
  font-weight: 600;
  margin: 40px 0 0 35px;
}

.rightTit {
  color: white;
  font-size: 26px;
  font-weight: 600;
  margin-top: 13px;
  // margin: 0px 0 0 35px;
  // text-align: center;
}
.image_box {
  margin-top: 32px;
}
.image_box > img {
  width: 250px;
}
/deep/ .el-input__inner {
  height: 50px;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #9f9fa0;
  font-size: 16px;
}

#login {
  width: 100%;
  height: 100%;
  // background: url("../../../static/images/bj.jpg") no-repeat;
  background: linear-gradient(
    to bottom right,
    #02072f,
    #4c40e0
  ); /* 标准的语法 */
  background-size: 100% 100%;
  position: relative;
  // background-color: #2d3a4b;
  // .loginConbox {
  //   background: #2d3a4b;
  // }
  //   .header {
  //     height: 60px;
  //     position: relative;
  //     //background: #2d3a4b;
  //     /*border-bottom: 1px solid rgba(255, 255, 255, 0.3);*/
  //     .logo {
  //       margin-left: 30px;
  //       width: 500px;
  //       float: left;
  //       height: 40px;
  //       padding-top: 10px;
  //       img {
  //         height: 100%;
  //       }
  //     }
  //   }
  .loginConbox {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: space-between;
    background-color: inherit;
    height: 500px;
    width: 1000px;
    border-radius: 10px;
  }
  .header {
    width: 50%;
    background-image: url("../../assets/images/leftBG.png");
    background-size: cover;
    border-radius: 10px 0 0 10px;
    background-color: inherit;
    // padding-left: 30px;
    box-sizing: border-box;
    text-align: center;
    color: #fff;
    .title {
      padding: 70px 20px 0 20px;
      font-size: 34px;
      line-height: 50px;
    }
    .subTitle {
      margin-top: 10px;
      font-size: 26px;
    }
    .lyLogo {
      width: 300px;
    }
  }

  .loginBox {
    height: 100%;
    width: 50%;
    background-color: white;
    border-radius: 0 10px 10px 0;
    .iconcolor {
      color: #409eff;
    }
    .loginCon {
      width: 100%;
      position: relative;
      height: 100%;
      padding-top: 20px;
      .title {
        margin: 0;
        margin-top: 40px;
        font-size: 30px;
        font-weight: 600;
        color: #091d7c;
        width: 100%;
        margin-left: 45px;
        // &:first-child {
        //   font-size: 34px;
        //   margin-right: -50px;
        //   margin-top: -10px;
        //   margin-bottom: 30px;
        // }
      }

      .demo-ruleForm {
        width: 80%;
        margin-top: 44px !important;
        margin-left: 45px;
        .label {
          font-size: 18px;
          color: #091d7c;
          font-weight: 600;
          margin-bottom: 8px;
        }
        .el-form-item {
          margin-bottom: 20px;
        }
      }

      .el-form-item__content {
        margin-left: 0px !important;

        .subBtn {
          width: 100%;
          //   margin-top: 40px;
          background-color: #091d7c;
          border: none;
          height: 40px;
          font-size: 17px;
          font-weight: 600;
        }
      }
    }

    .el-form-item__content .ico {
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 999;
      width: 40px;
      height: 39px;
      text-align: center;
      border-right: 1px solid #ccc;
    }

    .ewmbox {
      width: 100%;
      height: 240px;
      margin-top: -25px;

      .ewm {
        width: 140px;
        height: 140px;
        margin: 20px auto;

        p {
          font-size: 12px;
          padding-left: 40px;
          margin: 0;
        }
      }

      .ewmicon {
        width: 140px;
        margin: 20px auto 0;

        .iconfont {
          float: left;
        }

        p {
          font-size: 12px;
          padding-left: 40px;
          margin: 0;
        }
      }
    }
  }
}
.foot {
  text-align: center;
  height: 20px;
  line-height: 25px;
  font-size: 15px;
  color: #e1e1e1;
  position: absolute;
  left: 0;
  bottom: 100px;
  right: 0;
  z-index: 9999;
}
.foot p {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue